import React from 'react';
import axios from 'axios';
import Avatar from '@material-ui/core/Avatar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Conf from './Conf';

export default class Login extends React.Component {
  componentDidMount(){
    var cookie = localStorage.getItem(Conf.cookieName);
    cookie = JSON.parse(cookie);
    if(cookie && cookie.token) delete cookie.token;
    localStorage.setItem(Conf.cookieName,JSON.stringify(cookie));
  }
  render(){
    return <LoginForm />
  }
}
function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center" style={{fontSize:'.9em'}}>
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Chiang Mai University Library
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage: 'url('+process.env.PUBLIC_URL+'/img/login.jpg)',
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme.spacing(5, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,    
  },
}));

const getLogin=()=>{
  var cookie = localStorage.getItem(Conf.cookieName);
  cookie = JSON.parse(cookie);
  if(cookie && cookie.token) delete cookie.token;
  localStorage.setItem(Conf.cookieName,JSON.stringify(cookie));
  var callback = Conf.frontendURL+"auth";
  axios.post(Conf.authURL+"login",{callback:callback}).then(res=>{
    window.location = res.data.login_url;
    console.log(res.data);
  });
}

function LoginForm() {
  const classes = useStyles();

  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} className={classes.image} />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <Typography  variant="div" className={classes.paper}>
            <img src={`${process.env.PUBLIC_URL}/img/logo_cmul.png`} style={{maxWidth:'80%',marginBottom:'7vh'}} alt="" />
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography style={{color:'#666',fontSize:'1em',lineHeight:'50px'}}>
            Sign in
          </Typography>
          <Typography component="h1" variant="h5">
            CMUL e-Payment
          </Typography>
          <Typography component="button" variant="button" 
            style={{border:'1px solid #ccc',borderRadius:'5px',background:'#fefefe',marginTop:'60px',maxWidth:'60%'}}
            onClick={()=>getLogin()}
          >
            <img src={`${process.env.PUBLIC_URL}/img/logo-CMUOAuth-large-inverse2.png`} style={{maxWidth:'90%'}} alt="" />
          </Typography>
          <div style={{position:'absolute',right:'5px',bottom:'10px'}}>
            <Copyright />
          </div>
        </Typography>
      </Grid>
    </Grid>
  );
}